import { render, staticRenderFns } from "./GroupSubdivision.vue?vue&type=template&id=5c241f00&"
import script from "./GroupSubdivision.vue?vue&type=script&lang=ts&"
export * from "./GroupSubdivision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports